import PropTypes from 'prop-types'

const NonAuthLayout = ({ children }) => {
  return <div className="non-auth-layout">{children}</div>
}

NonAuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default NonAuthLayout
